let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fEMqy")).then(() => parcelRequire('5Y2tv'));